<script setup lang="ts">
import type { OrderFunding } from '../order-management';
defineProps<{ funding: OrderFunding }>();
const money = (v: number) =>
  new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(v / 100);
</script>
<template>
  <section class="funding" aria-label="Règlement de la commande">
    <p v-if="funding.reservedAmountMinor > 0">
      Réservé sur la carte : <strong>{{ money(funding.reservedAmountMinor) }}</strong
      >. Prélèvement à la livraison, au montant retenu.
    </p>
    <p>
      Prélevé : <strong>{{ money(funding.capturedAmountMinor) }}</strong
      ><template v-if="funding.refundedAmountMinor > 0">
        · Remboursé : <strong>{{ money(funding.refundedAmountMinor) }}</strong></template
      >
    </p>
    <p v-if="funding.bankReviewRequired" class="warning" role="alert">
      Opération bancaire à rapprocher avec l’administrateur. Commande suspendue.
    </p>
    <p v-else-if="funding.bankOperationPending" class="warning" role="status">
      Traitement bancaire en cours. La commande reste suspendue jusqu’à sa confirmation.
    </p>
    <p
      v-else-if="
        ['EXPIRED', 'CANCELED'].includes(funding.paymentStatus) &&
        funding.reservedAmountMinor === 0 &&
        funding.capturedAmountMinor === 0
      "
      role="status"
    >
      Aucun montant prélevé. L’empreinte n’est plus disponible.
    </p>
  </section>
</template>
<style scoped>
.funding {
  padding: 0.8rem;
  background: #eff6ff;
  color: #172033;
  border-radius: 0.7rem;
  overflow-wrap: anywhere;
}
p {
  margin: 0.4rem 0;
}
.warning {
  padding: 0.6rem;
  background: #fef3c7;
  color: #78350f;
  border-left: 4px solid #eab308;
}
</style>
